import React from "react"
import styled from "styled-components"
import Pattern from "../images/pattern.jpg"

const Wrapper = styled.header`
  width: 100%;
  height: 15vh;
  background-image: url(${Pattern});
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-content: center;
  align-items: center;
  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.darkBlue};
    opacity: 0.95;
  }
`
const StyledH1 = styled.h1`
  z-index: 99;
  font-weight: 400;
  letter-spacing: 2px;
  color: ${({ theme }) => theme.white};
  @media (max-width: 700px) {
    width: 100%;
    text-align: center;
  }
`

export const PageHeader = ({ children }) => (
  <Wrapper>
    <StyledH1>{children}</StyledH1>
  </Wrapper>
)
